import { paramsTypeObj } from './utils';
import { claimsParamAdd, claimsParamEdit } from './request';
export default {
  data() {
    return {
      paramsTypeObj,
      addVisible: false,
      addForm: {
        claimsParamId: null,
        name: '',
        code: '',
        description: '',
        type: '',
        sort: 0,
        isTag: 0
      },
      continueState: false,
      status: 'add',
      isContinue: true
    };
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('参数名称'),
          trigger: 'blur'
        }, {
          message: '1-50' + this.$t('字符'),
          max: 50,
          min: 1
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('参数代码'),
          trigger: 'blur'
        }, {
          message: '1-200' + this.$t('字符'),
          max: 200,
          min: 1
        }],
        sort: [{
          required: true,
          message: this.$t('请输入') + this.$t('排序数'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('控件'),
          trigger: 'change'
        }],
        isTag: [{
          required: true,
          message: this.$t('请选择') + this.$t('是否生成标签'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    openModal(status, info, isContinue) {
      this.isContinue = isContinue;
      this.status = status;
      if (info) {
        this.$nextTick(() => {
          Object.assign(this.addForm, info);
          this.addForm.type = String(info.type);
        });
      } else {
        if (this.addForm.name) {
          this.resetForm();
        }
      }
      this.addVisible = true;
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          let addParams;
          if (this.status === 'add') {
            this.addForm.claimsParamId = null;
            const res = await claimsParamAdd(Object.assign(this.addForm, {
              isContinue: this.isContinue
            }));
            addParams = res;
          } else {
            await claimsParamEdit(Object.assign(this.addForm, {
              isContinue: this.isContinue
            }));
          }
          this.$message.success(this.$t('保存成功'));
          this.$emit('save', addParams);
          if (this.continueState) {
            this.resetForm();
          } else {
            this.addVisible = false;
          }
        }
      });
    },
    closeAddVisible() {
      this.addVisible = false;
      this.continueState = false;
      this.resetForm();
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    }
  }
};